export default __webpack_public_path__ + "static/media/backuser.093ec897.jpg";